import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import withAuth from "../../components/withAuth";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DetailsTab from "../../components/SiteMonitoring/Tabs/DetailsTab";
import StructureTab from "../../components/SiteMonitoring/Tabs/StructureTab";
import PlansTab from "../../components/SiteMonitoring/Tabs/PlansTab";
import NotesTab from "../../components/SiteMonitoring/Tabs/NotesTab";
import SettingsTab from "../../components/SiteMonitoring/Tabs/SettingsTab";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon/Icon";
import Footer from "..//Layout/FooterFixedOnScreen";
import GetAppIcon from "@material-ui/icons/GetApp";
import { creatingNote } from "../../redux/siteMonitoring/noteActions";
import ReportTab from "../../components/SiteMonitoring/Tabs/ReportTab";
import {
    downloadReport,
    setSelectedTab,
    siteMonitoringIsDisabled,
    userIsSiteMonitoringManager,
} from "../../redux/siteMonitoring/siteMonitoringActions";
import { DETAILS_TAB_INDEX, NOTES_TAB_INDEX, PLANS_TAB_INDEX, REPORT_TAB_INDEX, SETTINGS_TAB_INDEX, STRUCTURE_TAB_INDEX } from "../../redux/siteMonitoring/siteMonitoringConstants";

const styles = {
    root: {
        minWidth: "40px",
        fontSize: "0.8em",
    },
};

class SiteMonitoring extends Component {
    constructor(props) {
        super(props);

        if (!this.props.siteMonitoring) this.props.history.push("/siteMonitorings");

        this.state = {
            pdfContainerRef: React.createRef(),
        };
    }

    handleChange = (event, value) => {
        this.props.setSelectedTab(value);
    };

    handleChangeIndex = (index) => {
        this.props.setSelectedTab(index);
    };

    onCreateClick() {
        this.props.creatingNote(this.props.siteMonitoring, this.props.activeUser);
    }

    downloadReport() {
        this.props.downloadReport(this.props.filteredAndSortedNotes, this.props.siteMonitoring, this.props.activeUser);
    }

    render() {
        if (!this.props.siteMonitoring) return <div />;

        const { classes } = this.props;
        let siteMonitoringDisabled = siteMonitoringIsDisabled(
            this.props.siteMonitoring,
            this.props.activeUser
        );

        return (
            <div>
                <div className="container-with-footer">
                    <AppBar position="static" color="default">
                        <Tabs
                            value={this.props.selectedTab}
                            onChange={this.handleChange}
                            variant="fullWidth"
                            scrollButtons="auto"
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab classes={classes} label={"Détails"} />
                            <Tab classes={classes} label={"Structure"}
                                disabled={!userIsSiteMonitoringManager(this.props.activeUser, this.props.siteMonitoring)} />
                            <Tab classes={classes} label={"Plans"} />
                            <Tab classes={classes} label={"Notes"} disabled={!this.props.lots.some((l) => !l.deleted)} />
                            <Tab classes={classes} label={"Rapport"} disabled={!this.props.lots.some((l) => !l.deleted)} />
                            <Tab classes={classes} label={"Config"}
                                disabled={!userIsSiteMonitoringManager(this.props.activeUser, this.props.siteMonitoring)} />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis="x"
                        index={this.props.selectedTab}
                        onChangeIndex={this.handleChangeIndex}
                    >
                        <DetailsTab selectedTab={this.props.selectedTab === DETAILS_TAB_INDEX} />
                        <StructureTab selectedTab={this.props.selectedTab === STRUCTURE_TAB_INDEX} />
                        <PlansTab selectedTab={this.props.selectedTab === PLANS_TAB_INDEX} />
                        <NotesTab selectedTab={this.props.selectedTab === NOTES_TAB_INDEX} />
                        <ReportTab selectedTab={this.props.selectedTab === REPORT_TAB_INDEX}
                            pdfContainerRef={this.state.pdfContainerRef} />
                        <SettingsTab selectedTab={this.props.selectedTab === SETTINGS_TAB_INDEX}
                            siteMonitoringDisabled={siteMonitoringDisabled} />
                    </SwipeableViews>
                </div>
                {this.props.selectedTab === NOTES_TAB_INDEX ||
                    this.props.selectedTab === REPORT_TAB_INDEX ? (
                    <Footer>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                            {!siteMonitoringDisabled &&
                                this.props.selectedTab === NOTES_TAB_INDEX ? (
                                <div className="offset-lg-11 col-lg-1 offset-md-10 col-md-2 offset-sm-8 col-sm-4 offset-sm-6 col-6">
                                    <div className="center">
                                        <Fab color="primary" className="div-center" onClick={this.onCreateClick.bind(this)} >
                                            <Icon>add</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">
                                            Créer note
                                        </span>
                                    </div>
                                </div>
                            ) : null}
                            {this.props.selectedTab === REPORT_TAB_INDEX ? (
                                <div className="offset-lg-11 col-lg-1 offset-md-10 col-md-2 offset-sm-8 col-sm-4 offset-sm-6 col-6">
                                    <div className="center">
                                        <Fab className="div-center green-button" onClick={this.downloadReport.bind(this)} >
                                            <GetAppIcon />
                                        </Fab>
                                        <span className="floating-btn-text span-center">
                                            Télécharger
                                        </span>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </Footer>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        selectedTab: state.siteMonitoring.selectedTab,
        lots: state.siteMonitoring.lots,
        siteMonitoringListFilters: state.siteMonitorings.siteMonitoringsFilters,
        activeUser: state.activeUser,
        filteredAndSortedNotes: state.notes.filteredAndSortedNotes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        creatingNote: (siteMonitoring, user) =>
            dispatch(creatingNote(siteMonitoring, user)),
        downloadReport: (notes, siteMonitoring, activeUser) =>
            dispatch(downloadReport(notes, siteMonitoring, activeUser)),
        setSelectedTab: (selectedTab) => dispatch(setSelectedTab(selectedTab)),
    };
};

export default compose(
    withStyles(styles),
    withAuth,
    connect(mapStateToProps, mapDispatchToProps)
)(SiteMonitoring);
